import KibanaFilterModel from './osd-filter-model';
export default class LessThanFilterModel extends KibanaFilterModel {
    range;
    constructor(metadata) {
        super(metadata);
        if (!metadata.key)
            return;
        const [from, to] = metadata.value.split('to').map(item => Number(item));
        this.range = {
            [metadata.key]: {
                gte: null,
                lt: isNaN(to) ? null : to,
            },
        };
    }
}
//# sourceMappingURL=less-than-filter-model.js.map